var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "itemPanel",
    style: {
      height: _vm.height + "px"
    }
  }, [_c("el-collapse", {
    model: {
      value: _vm.activeNames,
      callback: function callback($$v) {
        _vm.activeNames = $$v;
      },
      expression: "activeNames"
    }
  }, [_c("el-collapse-item", {
    attrs: {
      title: _vm.i18n["start"],
      name: "1"
    }
  }, [_c("img", {
    staticStyle: {
      width: "42px",
      height: "42px"
    },
    attrs: {
      "data-item": "{clazz:'start',size:'50*50',label:''}",
      src: require("../assets/flow/start.svg")
    }
  }), _c("div", [_vm._v(_vm._s(_vm.i18n["startEvent"]))])]), _c("el-collapse-item", {
    attrs: {
      title: _vm.i18n["task"],
      name: "2"
    }
  }, [_c("img", {
    staticStyle: {
      width: "80px",
      height: "44px"
    },
    attrs: {
      "data-item": _vm.userTaskData,
      src: require("../assets/flow/user-task.svg")
    }
  }), _c("div", [_vm._v(_vm._s(_vm.i18n["userTask"]))])]), _c("el-collapse-item", {
    attrs: {
      title: _vm.i18n["gateway"],
      name: "3"
    }
  }, [_c("img", {
    staticStyle: {
      width: "48px",
      height: "48px"
    },
    attrs: {
      "data-item": "{clazz:'exclusiveGateway',size:'60*60',label:''}",
      src: require("../assets/flow/exclusive-gateway.svg")
    }
  }), _c("div", [_vm._v(_vm._s(_vm.i18n["exclusiveGateway"]))]), _c("img", {
    staticStyle: {
      width: "48px",
      height: "48px"
    },
    attrs: {
      "data-item": "{clazz:'parallelGateway',size:'60*60',label:''}",
      src: require("../assets/flow/parallel-gateway.svg")
    }
  }), _c("div", [_vm._v(_vm._s(_vm.i18n["parallelGateway"]))]), _c("img", {
    staticStyle: {
      width: "48px",
      height: "48px"
    },
    attrs: {
      "data-item": "{clazz:'inclusiveGateway',size:'60*60',label:''}",
      src: require("../assets/flow/inclusive-gateway.svg")
    }
  }), _c("div", [_vm._v(_vm._s(_vm.i18n["inclusiveGateway"]))])]), _c("el-collapse-item", {
    attrs: {
      title: _vm.i18n["end"],
      name: "5"
    }
  }, [_c("img", {
    staticStyle: {
      width: "42px",
      height: "42px"
    },
    attrs: {
      "data-item": "{clazz:'end',size:'50*50',label:''}",
      src: require("../assets/flow/end.svg")
    }
  }), _c("div", [_vm._v(_vm._s(_vm.i18n["endEvent"]))])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };